import { useIntl } from 'react-intl'

import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import styled from 'styled-components'

export default function Tips(): JSX.Element {
  const intl = useIntl()

  const questions = [
    {
      question: intl.formatMessage({ id: 'courseEditor.questions.canISendGpsData' }),
      answer: intl.formatMessage({
        id: 'courseEditor.answers.canISendGpsData',
      }),
    },
    {
      question: intl.formatMessage({ id: 'courseEditor.questions.whatIfCourseHas9Holes' }),
      answer: intl.formatMessage({ id: 'courseEditor.answers.whatIfCourseHas9Holes' }),
    },
    {
      question: intl.formatMessage({ id: 'courseEditor.questions.courseHasNotUpdated' }),
      answer: intl.formatMessage({ id: 'courseEditor.answers.courseHasNotUpdated' }),
    },
    {
      question: intl.formatMessage({ id: 'courseEditor.questions.teesNotRatedBothGenders' }),
      answer: intl.formatMessage({ id: 'courseEditor.answers.teesNotRatedBothGenders' }),
    },
    {
      question: intl.formatMessage({ id: 'courseEditor.questions.termsInCourseData' }),
      answer: (
        <>
          <DefinitionTitle variant="h6">
            {intl.formatMessage({ id: 'courseEditor.answers.termsInCourseData.holeHcpOrStrokeIndexTitle' })}
          </DefinitionTitle>
          <DefinitionParagraph variant="body1">
            {intl.formatMessage({ id: 'courseEditor.answers.termsInCourseData.holeHcpOrStrokeIndexDefinition' })}
          </DefinitionParagraph>
          <DefinitionTitle variant="h6">
            {intl.formatMessage({ id: 'courseEditor.answers.termsInCourseData.courseRatingTitle' })}
          </DefinitionTitle>
          <DefinitionParagraph variant="body1">
            {intl.formatMessage({ id: 'courseEditor.answers.termsInCourseData.courseRatingDefinition' })}
          </DefinitionParagraph>
          <DefinitionTitle variant="h6">
            {intl.formatMessage({ id: 'courseEditor.answers.termsInCourseData.slopeRatingTitle' })}
          </DefinitionTitle>
          <DefinitionParagraph variant="body1">
            {intl.formatMessage({ id: 'courseEditor.answers.termsInCourseData.slopeRatingDefinition' })}
          </DefinitionParagraph>
        </>
      ),
    },
    {
      question: intl.formatMessage({ id: 'courseEditor.questions.howToAddCourse' }),
      answer: intl.formatMessage({ id: 'courseEditor.answers.howToAddCourse' }),
    },
  ]

  return (
    <Container>
      <Title>{intl.formatMessage({ id: 'courseEditor.commonQuestionsTitle' })}</Title>
      {questions.map((question, index) => (
        <QuestionContainer elevation={0} key={index}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ border: 'none' }}>
            <QuestionTitle>{question.question}</QuestionTitle>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>{question.answer}</Typography>
          </AccordionDetails>
        </QuestionContainer>
      ))}
      <ContactSupport>
        {intl.formatMessage({ id: 'courseEditor.cantFindAnswer' })}{' '}
        <ContactSupportLink href="https://support.golfgamebook.com/hc/en-us" target="_blank">
          {intl.formatMessage({ id: 'courseEditor.contactSupport' })}
        </ContactSupportLink>
      </ContactSupport>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 505px;
`

const Title = styled.h1`
  color: #032615;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  margin: 50px 0;
`

const QuestionTitle = styled.h3`
  color: #032615;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
`

const QuestionContainer = styled(Accordion)`
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  box-shadow: none;

  margin-bottom: 10px;

  &.MuiAccordion-root:before {
    height: 0px;
  }

  .MuiAccordionDetails-root {
    padding-bottom: 40px;
  }
`

const ContactSupport = styled.div`
  color: #8a8a8e;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  margin-top: 50px;
`

const ContactSupportLink = styled.a`
  color: #8a8a8e;
  font-weight: 500;
`

const DefinitionTitle = styled(Typography)`
  font-weight: 600;
  margin-bottom: 8px;
`

const DefinitionParagraph = styled(Typography)`
  margin-bottom: 16px;
`
